import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import { EmptyState } from '../components/ui';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <EmptyState
      title={t('common.noResults')}
      hint={t('common.notFoundHint')}
      action={
        <Link to="/" className="text-body-sm text-primary-600 underline-offset-4 hover:underline dark:text-primary-400">
          {t('common.backHome')}
        </Link>
      }
    />
  );
}
